import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, EventEmitter, Injector, Input, OnInit, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable, Subscription } from 'rxjs';
import { AppComponentBase } from '@shared/app-component-base';
import { ChatMensagemDto, ChatServiceServiceProxy } from '@shared/service-proxies/service-proxies';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import * as FileSaver from "file-saver";
import { FileHelper } from '../../../helpers/FileHelper';
import { StringUtils } from '@shared/helpers/StringUtils';
import { NewMessageDto } from '@shared/model/new-message';
import * as moment from '@node_modules/moment-timezone';
import { emit } from 'process';

type anexo = {
  anexoB64: string,
  extensao: string,
  nome: string
}

type chatUserName = {
  equipeId: string;
  name: string;
  profissionaisNames: string[]
  profissionaisIds: number[]
};

@Component({
  selector: 'chat-messages',
  templateUrl: './chat-messages.component.html',
  styleUrls: ['./chat-messages.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ChatMessagesComponent extends AppComponentBase implements OnInit {

  private eventRolarMensagensSubscription: Subscription;
  @Input() destinatarioId: number;
  @Input() equipeId: string;
  @Input() chatMensagens: ChatMensagemDto[] = [];
  @Input() equipe: chatUserName;

  static envioMensagem = new EventEmitter<any>();
  static atualizarChat = new EventEmitter<NewMessageDto>();
  mensagemDto: ChatMensagemDto = new ChatMensagemDto;
  mensagem: string;
  exibirInputTexto: boolean = true;
  selectedFiles: File[] = [];
  objectUrls: SafeUrl[] = [];
  anexosB64: anexo[] = [];
  horarioAtualizacao: string;
  public isSent: boolean = false;

  @Input() eventRolarMensagens: Observable<void>;
  @ViewChild('scrollContainer') private scrollContainerRef: ElementRef;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  public modalRef: BsModalRef;

  constructor(
    injector: Injector,
    private _chatService: ChatServiceServiceProxy,
    private _router: Router,
    private sanitizer: DomSanitizer,
    private _modalService: BsModalService,
    private cdr: ChangeDetectorRef,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.eventRolarMensagensSubscription = this.eventRolarMensagens.subscribe(() => {
      this.scrollToBottom();
      this.mensagem = null;
      this.selectedFiles = [];
      this.objectUrls = [];
      this.exibirInputTexto = true;
      var dataAtual = new Date();
      this.horarioAtualizacao = String(dataAtual.getHours()).padStart(2, "0") + ":" + String(dataAtual.getMinutes()).padStart(2, "0");
      this.cdr.markForCheck();
    });
  }

  scrollToBottom(): void {
    if (this.chatMensagens.length > 0) {
      const element = this.scrollContainerRef.nativeElement;
      element.scrollTop = element.scrollHeight;
    }
  }

  async enviarMensagem(temArquivo: boolean) {
    if (temArquivo) {
      this.isSent = true;
      var mensagens: ChatMensagemDto[] = [];
      await this.setAnexos(this.selectedFiles).then(x => {
        let isFirst = true;
        this.anexosB64.forEach(anexo => {
          let mensagem = new ChatMensagemDto();
          mensagem.equipeId = this.equipeId;
          mensagem.mensagem = isFirst ? this.mensagem : "";
          isFirst = false;
          mensagem.anexoB64 = anexo.anexoB64;
          mensagem.nomeArquivo = anexo.nome;
          mensagem.extensaoArquivo = anexo.extensao;
          mensagens.push(mensagem);
        });
      });
      this._chatService.enviarAnexos(mensagens)
        .pipe()
        .subscribe(x => {
          this.removeFiles();

          if (this.selectedFiles.length == 0 && this.exibirInputTexto == false)
            this.exibirInputTexto = true;

          this.cdr.markForCheck();
          var newMessage = this.getNewMessage();
          ChatMessagesComponent.atualizarChat.emit(newMessage);
          this.isSent = false;
        });
    }
    else if (!StringUtils.isNullOrEmpty(this.mensagem)) {
      this.isSent = true;
      this.mensagemDto.equipeId = this.equipeId;
      this.mensagemDto.mensagem = this.mensagem;
      this._chatService.enviarMensagem(this.mensagemDto)
        .pipe()
        .subscribe(x => {
          this.mensagem = null;
          this.cdr.markForCheck();
          var newMessage = this.getNewMessage();
          ChatMessagesComponent.atualizarChat.emit(newMessage);
          this.isSent = false;
        });
    }
  }

  verificaLado(mensagem: ChatMensagemDto) {
    if (mensagem.remetenteId == this.appSession.userId) return "direita";
    return "esquerda";
  }

  verificaCor(mensagem: ChatMensagemDto) {
    if (mensagem.remetenteId == this.appSession.userId) return "isRemetente";
    return "isDestinatario";
  }

  isRemetente(mensagem: ChatMensagemDto) {
    return mensagem.remetenteId == this.appSession.userId
  }

  onFilesSelected(files: FileList) {
    if (this.exibirInputTexto == true)
      this.exibirInputTexto = false

    const allowedExtensions = ['image/jpeg', 'image/png', 'image/gif', 'video/mp4', 'video/avi', 'video/mov', 'application/pdf'];

    this.selectedFiles.push(...Array.from(files).filter(file => allowedExtensions.includes(file.type)));

    this.updateObjectUrls();
  }

  updateObjectUrls() {
    this.objectUrls = this.selectedFiles.map((file) => this.sanitizer.bypassSecurityTrustUrl(URL.createObjectURL(file)));
  }

  removeFile(index: number) {
    this.selectedFiles.splice(index, 1);
    this.objectUrls.splice(index, 1);

    if (this.selectedFiles.length == 0 && this.objectUrls.length == 0 && this.exibirInputTexto == false)
      this.exibirInputTexto = true;
  }

  removeFiles() {
    this.selectedFiles = [];
    this.objectUrls = [];
    this.exibirInputTexto = true;

    if (this.fileInput?.nativeElement) this.fileInput.nativeElement.value = '';

  }

  isImage(file: File): boolean {
    return file.type.startsWith('image');
  }

  isImageByExtension(extensao: string) {
    var extensoesImagem = ['image/jpeg', 'image/png'];
    var isImage = extensoesImagem.includes(extensao);
    return isImage;
  }

  async setAnexos(files: File[]) {
    var anexos: anexo[] = [];

    for (const file of files) {
      let anexo: anexo = {
        anexoB64: await FileHelper.fileToBase64(file),
        extensao: file.type,
        nome: file.name
      };

      anexos.push(anexo);
    }

    this.anexosB64 = anexos;
  }

  async abrirFotoGrande(template, chatMensagem: ChatMensagemDto) {
    if (this.isImageByExtension(chatMensagem.extensaoArquivo)) {
      this.modalRef = this._modalService.show(template,
        {
          class: "modal-dialog-centered modal-md",
        });
      this.modalRef.content = chatMensagem.url;
    }
    else {
      FileSaver.saveAs(chatMensagem.url, chatMensagem.nomeArquivo);
    }
  }

  adicionarData(mensagem: ChatMensagemDto) {
    var posicaoMensagem = this.chatMensagens.findIndex(x => x.id == mensagem.id);
    if (posicaoMensagem == 0) {
      return true;
    }
    else if (posicaoMensagem > 0 && this.chatMensagens[posicaoMensagem - 1].dataHoraEnvio.format("DD/MM/YYYY") != mensagem.dataHoraEnvio.format("DD/MM/YYYY")) {
      return true;
    }
    return false;
  }

  getParticipantes(): string {
    const nomes = this.equipe.profissionaisNames.filter(x => x != this.appSession.user.name);

    if (!nomes || nomes.length === 0) {
      return "Você";
    }

    if (nomes.length <= 4) {
      return `Você, ${nomes.join(", ")}`;
    }

    const primeirosNomes = nomes.slice(0, 4).join(", ");
    const restantes = nomes.length - 4;

    return `Você, ${primeirosNomes} e +${restantes}`;
  }

  protected getNewMessage(): NewMessageDto {
    var message = new NewMessageDto();
    message.equipeId = this.equipeId;
    message.mensagem = this.mensagemDto.mensagem;
    message.dataHora = moment();
    message.remetenteId = this.appSession.userId;
    return message
  }

  protected baixarImagem(chatMensagem: ChatMensagemDto) {
    FileSaver.saveAs(chatMensagem.url, chatMensagem.nomeArquivo);
  }
}
